'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _components = require('@bodhi-project/components');

var _typography = require('@bodhi-project/typography');

var _2 = require('./');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Abstract stuff
// eslint-disable-line import/no-extraneous-dependencies
// import PropTypes from 'prop-types';
var Fragment = _react2.default.Fragment;
// import { css } from 'glamor';
// import moment from 'moment';

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Components
// ------------------------------------------------------------------------------
// ---------------------------------------------------------------------- Imports
// ------------------------------------------------------------------------------
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Libraries

var Paragraph = _typography.Elements.Paragraph;

// ------------------------------------------------------------------------------
// -------------------------------------------------------------------- Component
// ------------------------------------------------------------------------------
/**
  * parseParagraph
  */

var parseParagraph = function parseParagraph(element) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var descendants = element.children;

  return _react2.default.createElement(
    Paragraph,
    null,
    descendants.map(function (descendant) {
      var type = descendant.type;

      var frag = _react2.default.createElement(Fragment, null);
      // console.log(descendant);
      switch (type) {
        case 'text':
          if (descendant.value === "\n") {
            return _react2.default.createElement('br', null);
          } else {
            return descendant.value;
          }
        case 'break':
          return _react2.default.createElement('br', null);
        case 'link':
          frag = (0, _2.linkParser)(descendant);
          return frag;
        case 'emphasis':
          return _react2.default.createElement(
            'i',
            null,
            descendant.children[0].value
          );
        case 'strong':
          return _react2.default.createElement(
            'strong',
            null,
            descendant.children[0].value
          );
        case 'html':
          return _react2.default.createElement('br', null);
        default:
          return frag;
      }
    })
  );
};

parseParagraph.propTypes = process.env.NODE_ENV !== "production" ? {} : {};

// ------------------------------------------------------------------------------
// ----------------------------------------------------------------------- Export
// ------------------------------------------------------------------------------
exports.default = parseParagraph;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/@bodhi-project/markdown-to-react/lib/parsers/paragraphParser.js
// module id = 440
// module chunks = 168707334958949